import mitt from 'mitt';

export const modalBus = mitt();
